module.exports = __webpack_public_path__ + "img/1-r.3ecf7cf9.png";